.fila {
  display: grid;
  grid-template-columns: 1fr 64px;
  gap: var(--s-2) var(--s-5);
  align-items: center;
  padding: var(--s-5) 0;
  border-bottom: var(--bw-hair) solid var(--border-hair);
}
.etiqueta {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-strong);
}
.valor {
  font-family: var(--font-mono);
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  font-variant-numeric: tabular-nums;
  text-align: right;
  color: var(--text-strong);
}
.pista {
  grid-column: 1 / -1;
  display: block;
  height: var(--s-2);
  border-radius: var(--r-full);
  background: var(--surface-muted);
  overflow: hidden;
}
.barra {
  display: block;
  height: 100%;
  width: var(--_share, 0%);
  background: var(--_color, var(--action-primary));
  transition: width var(--dur-slow) var(--ease-out);
}
@media (prefers-reduced-motion: reduce) {
  .barra {
    transition: none;
  }
}
